import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HorizontalChart from './icon-horizontal-chart.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HorizontalChart {...validProps} />;
}
SvgComponent.iconName = 'horizontalChart';

/**
 * @deprecated This is a legacy icon
 */
export const HorizontalChartIcon = svgIconWrapper(SvgComponent);
